import React from 'react';
import { LucideIcon } from 'lucide-react';

interface MetricCardProps {
    icon: LucideIcon;
    value: number | string;
    label: string;
}

export const MetricCard = ({ icon: Icon, value, label }: MetricCardProps) => {
    return (
        <div className="metric-card text-center">
            <div className="flex items-center justify-center mb-2">
                <Icon className="w-6 h-6 text-primary" />
            </div>
            <p className="text-2xl font-bold dark:text-white text-slate-800">
                {value}
            </p>
            <p className="text-sm font-medium text-slate-500 dark:text-slate-400">
                {label}
            </p>
        </div>
    );
};